
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Languages"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"apiToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiToken"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"result"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"altitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"direction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mileage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMoving"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ignition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"virtualIgnition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gprsBaseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gprsLocationCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gprsNetworkCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gprsStrength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batteryVoltage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batteryCharging"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceVoltage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supercourseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"courseId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"holeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geofenceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receivedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gameAllowedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gameAverage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gameStartAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hdop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"killBoxParameters"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":727}};
    doc.loc.source = {"body":"query getList ($language: Languages, $apiToken: String!){\n  messages(language: $language, apiToken: $apiToken) {\n    status,\n    errors,\n    result {\n      id\n      latitude\n      longitude\n      altitude\n      speed\n      direction\n      mileage\n      state\n      isMoving\n      ignition\n      virtualIgnition\n      gprsBaseId\n      gprsLocationCode\n      gprsNetworkCode\n      gprsStrength\n      batteryLevel\n      batteryVoltage\n      batteryCharging\n      sourceVoltage\n      sourceState\n      sourceLevel\n      unitId\n      supercourseId\n      courseId\n      holeId\n      geofenceId\n      receivedAt\n      gameAllowedTime\n      gameAverage\n      gameStartAt\n      hdop\n      satellites\n      killBoxParameters\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getList"] = oneQuery(doc, "getList");
        
